import { UI, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import React, { useEffect } from 'react';

import { InputMoney } from '../../../../../../../../../components/InputMoney';
import { ResponsiveSuccessIconButton } from '../../../../../../../../../components/ResponsiveSuccessIconButton';
import { RiskRating } from '../../../../../../../../../components/RiskRating';
import { TableContentItemCaptions } from '../../../../../../../../../components/TableContent';
import { useFundsAssetController } from '../../../../../hooks/products/Funds';
import { LateralBar } from '../../../components/LateralBar';

import { FundsItemSelectedTypes } from '.';

export const FundsItemSelectedMobile: React.FC<FundsItemSelectedTypes.Props> = ({
  offer,
  onUpdate,
  hideLateralBar = false,
}) => {
  const id = offer.productIdNormalized;
  const {
    control,
    handleInputBlur,
    handleInputClear,
    handleInputFocus,
    handleSubmit,
    hasError,
    helpText,
    isFocused,
    currentValueFormatted,
    currentValue,
  } = useFundsAssetController(offer);

  useEffect(() => {
    if (offer.orderValue === currentValue) {
      return;
    }
    const updatedOffer = { ...offer, orderValue: currentValue || 0 };
    onUpdate(updatedOffer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue]);

  const middleInfos = [
    {
      label: 'Tipo',
      value: <UI.Text color="neutral.dark">{offer.productCategoryNormalized}</UI.Text>,
    },
    {
      label: 'Rent. 12 meses',
      value: <UI.Text color="neutral.dark">{offer.profitabilityTwelveMonthsNormalized}</UI.Text>,
    },
    {
      label: 'Taxa admin.',
      value: <UI.Text color="neutral.dark">{offer.administrationFeeNormalized}</UI.Text>,
    },
    {
      label: 'Resgate',
      value: (
        <UI.Text color="neutral.dark">{offer.quotationRedemptionTermFormattedNormalized}</UI.Text>
      ),
    },
    {
      label: 'Risco',
      value: (
        <RiskRating
          currentRiskRating={Number(offer.riskRatingLevelNormalized) || 0}
          tooltip={offer.riskRatingNormalized || ''}
        />
      ),
    },
    {
      label: 'Aplicação mínima',
      value: <UI.Text color="neutral.dark">{offer.applicationMinimumAmount}</UI.Text>,
    },
  ];

  return (
    <VStack space="stack.xxxs" w="full">
      {!hideLateralBar && (
        <LateralBar
          backgroundColor="product.fundos"
          borderTopLeftRadius={BoxRadius.sm}
          borderBottomLeftRadius={BoxRadius.sm}
        />
      )}
      <VStack space="stack.nano">
        <UI.Text variant="semibold" color="neutral.black">
          {offer.productNameNormalized}
        </UI.Text>
        <TableContentItemCaptions icons={offer.captions} forceDesktop />
      </VStack>
      <VStack space="stack.nano" flexGrow={1}>
        {middleInfos.map(({ label, value }) => (
          <HStack space="inline.quarck" justifyContent="space-between" key={label}>
            <UI.Text color="neutral.black" variant="semibold">
              {label}
            </UI.Text>
            {value}
          </HStack>
        ))}
      </VStack>
      <HStack
        space={Spacing['inline.xxxs']}
        justifyContent="space-between"
        w="full"
        alignItems="flex-end">
        <VStack space={Spacing['stack.quarck']} flexGrow={1}>
          <UI.Text color="neutral.black" variant="semibold">
            Valor aplicado:
          </UI.Text>
          <VStack flex={1}>
            <InputMoney
              id={`fixedIncome-input${id}`}
              name="createAppliedAmount"
              control={control}
              handleFocus={handleInputFocus}
              handleBlur={handleInputBlur}
              handleSubmit={handleSubmit}
              handleClear={handleInputClear}
              currentValue={currentValueFormatted}
              hasFocus={isFocused}
              minValue={offer.applicationMinimumAmount || 0}
              customInputProps={{
                ...{ ...(isFocused && hasError && { error: hasError }) },
                ...{ ...(isFocused && !hasError && { helpText }) },
              }}
            />
          </VStack>
        </VStack>
        <ResponsiveSuccessIconButton />
      </HStack>
    </VStack>
  );
};
